import React from 'react'
import styles from './styles.css'
import {logout} from 'App/helpers/meteor-apollo-accounts'
import {withApollo} from 'react-apollo'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import Button from 'orionsoft-parts/lib/components/Button'
import RetryIcon from 'react-icons/lib/md/repeat'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import {withRouter} from 'react-router'

@withMutation(gql`
  mutation resendAuthorizeSessionEmail {
    resendAuthorizeSessionEmail {
      success
    }
  }
`)
@withApollo
@withMessage
@withRouter
export default class Authorize extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    showMessage: PropTypes.func,
    client: PropTypes.object,
    resendAuthorizeSessionEmail: PropTypes.func
  }

  state = {}

  @autobind
  async resend() {
    this.setState({loadingResend: true})
    try {
      await this.props.resendAuthorizeSessionEmail()
      this.props.showMessage('Te reenviamos el mensaje')
    } catch (error) {
      console.error(error)
      this.props.showMessage(error.message)
    }
    this.setState({loadingResend: false})
  }

  @autobind
  async logout() {
    this.setState({logginOut: true})
    await logout(this.props.client)
    this.props.router.push('/login')
  }

  render() {
    return (
      <div className={styles.container}>
        
        <h2 className="tds-orionx-font-dm__h5">
          Revisa tu correo electrónico
          {/* Te enviamos un correo */}
        </h2>
        
        <p className="tds-orionx-font-dm__body">
          {/* Te enviamos las intrucciones para entrar a la plataforma */}
          Te enviamos las intrucciones para iniciar sesión
        </p>
        
        <div className={styles.buttons}>
          <Button 
            onClick={this.resend} 
            loading={this.state.loadingResend}
            className="tds-orionx-override-btn tds-orionx-override-btn--secondary">
            <RetryIcon style={{marginRight: 5}} /> Reenviar email
          </Button>
        </div>
        <div className={styles.cancelButton}>
          <a onClick={this.logout} loading={this.state.logginOut}>
            Cancelar inicio de sesión
          </a>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Root/ApolloError/UnauthorizedSession/Authorize/index.js